var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPipeIcon = function SvgPipeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.311,
    height: 36.311
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "pipe-icon_svg__a",
    width: 36.311,
    height: 36.311,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5627"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#pipe-icon_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 211",
    style: {
      fill: "#0b81c3",
      stroke: "#fff"
    },
    transform: "rotate(-1 423.487 -570.38)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8.5,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M11.281 8.057h-5.06a1.343 1.343 0 0 1-1.343-1.343V4.7h-.234a.376.376 0 1 1 0-.752h.234v-.666H1.219A.61.61 0 0 1 0 3.27V.609A.61.61 0 0 1 1.219.6h5.059a1.343 1.343 0 0 1 1.343 1.34v2.011h.234a.376.376 0 1 1 0 .752h-.234v.669h3.66a.61.61 0 0 1 1.219.014v2.658a.61.61 0 0 1-1.219.013",
    "data-name": "Union 10",
    style: {
      fill: "#fff"
    },
    transform: "translate(11.906 10.83)"
  })));
};
export { SvgPipeIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNi4zMTEiIGhlaWdodD0iMzYuMzExIiB2aWV3Qm94PSIwIDAgMzYuMzExIDM2LjMxMSI+CiAgICA8ZGVmcz4KICAgICAgICA8ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIiB3aWR0aD0iMzYuMzExIiBoZWlnaHQ9IjM2LjMxMSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgICAgICAgPGZlT2Zmc2V0IGR5PSIzIi8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjMiIHJlc3VsdD0iYmx1ciIvPgogICAgICAgICAgICA8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIuMTYxIi8+CiAgICAgICAgICAgIDxmZUNvbXBvc2l0ZSBvcGVyYXRvcj0iaW4iIGluMj0iYmx1ciIvPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgaW49IlNvdXJjZUdyYXBoaWMiLz4KICAgICAgICA8L2ZpbHRlcj4KICAgIDwvZGVmcz4KICAgIDxnIGRhdGEtbmFtZT0iR3JvdXAgNTYyNyI+CiAgICAgICAgPGcgc3R5bGU9ImZpbHRlcjp1cmwoI2EpIj4KICAgICAgICAgICAgPGcgZGF0YS1uYW1lPSJFbGxpcHNlIDIxMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTEgNDIzLjQ4NyAtNTcwLjM4KSIgc3R5bGU9ImZpbGw6IzBiODFjMztzdHJva2U6I2ZmZiI+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgc3R5bGU9InN0cm9rZTpub25lIi8+CiAgICAgICAgICAgICAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOC41IiBzdHlsZT0iZmlsbDpub25lIi8+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICAgICAgPHBhdGggZGF0YS1uYW1lPSJVbmlvbiAxMCIgZD0iTTExLjI4MSA4LjA1N2gtNS4wNmExLjM0MyAxLjM0MyAwIDAgMS0xLjM0My0xLjM0M1Y0LjdoLS4yMzRhLjM3Ni4zNzYgMCAxIDEgMC0uNzUyaC4yMzR2LS42NjZIMS4yMTlBLjYxLjYxIDAgMCAxIDAgMy4yN1YuNjA5QS42MS42MSAwIDAgMSAxLjIxOS42aDUuMDU5YTEuMzQzIDEuMzQzIDAgMCAxIDEuMzQzIDEuMzR2Mi4wMTFoLjIzNGEuMzc2LjM3NiAwIDEgMSAwIC43NTJoLS4yMzR2LjY2OWgzLjY2YS42MS42MSAwIDAgMSAxLjIxOS4wMTR2Mi42NThhLjYxLjYxIDAgMCAxLTEuMjE5LjAxM3oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjkwNiAxMC44MykiIHN0eWxlPSJmaWxsOiNmZmYiLz4KICAgIDwvZz4KPC9zdmc+Cg==";